//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../axios-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * returns user activities on assessment
 * @return OK
 */
export function assessmentGET(config?: AxiosRequestConfig | undefined): Promise<Types.GetAssessmentActivitiesResponse> {
    let url_ = getBaseUrl() + "/api/v1/activity/assessment";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigAssessmentGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigAssessmentGET?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAssessmentGET(_response);
    });
}

function processAssessmentGET(response: AxiosResponse): Promise<Types.GetAssessmentActivitiesResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetAssessmentActivitiesResponse.fromJS(resultData200);
        return Promise.resolve<Types.GetAssessmentActivitiesResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetAssessmentActivitiesResponse>(null as any);
}

/**
 * returns user activities on courses
 * @return OK
 */
export function courseGET(config?: AxiosRequestConfig | undefined): Promise<Types.GetCourseActivitiesResponse> {
    let url_ = getBaseUrl() + "/api/v1/activity/course";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigCourseGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigCourseGET?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCourseGET(_response);
    });
}

function processCourseGET(response: AxiosResponse): Promise<Types.GetCourseActivitiesResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetCourseActivitiesResponse.fromJS(resultData200);
        return Promise.resolve<Types.GetCourseActivitiesResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetCourseActivitiesResponse>(null as any);
}

/**
 * returns graph of user activities
 * @return OK
 */
export function graph(config?: AxiosRequestConfig | undefined): Promise<Types.GetActivityGraphResponse> {
    let url_ = getBaseUrl() + "/api/v1/activity/graph";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGraph,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGraph?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGraph(_response);
    });
}

function processGraph(response: AxiosResponse): Promise<Types.GetActivityGraphResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetActivityGraphResponse.fromJS(resultData200);
        return Promise.resolve<Types.GetActivityGraphResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetActivityGraphResponse>(null as any);
}

/**
 * returns user activities on interviews
 * @return OK
 */
export function interviewGET(config?: AxiosRequestConfig | undefined): Promise<Types.GetInterviewActivitiesResponse> {
    let url_ = getBaseUrl() + "/api/v1/activity/interview";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigInterviewGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigInterviewGET?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processInterviewGET(_response);
    });
}

function processInterviewGET(response: AxiosResponse): Promise<Types.GetInterviewActivitiesResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetInterviewActivitiesResponse.fromJS(resultData200);
        return Promise.resolve<Types.GetInterviewActivitiesResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetInterviewActivitiesResponse>(null as any);
}

/**
 * returns user activities on interviews grouped by interview category type
 * @return OK
 */
export function all(config?: AxiosRequestConfig | undefined): Promise<{ [key: string]: Types.GetInterviewActivitiesResponse; }> {
    let url_ = getBaseUrl() + "/api/v1/activity/interview/all";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigAll,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigAll?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAll(_response);
    });
}

function processAll(response: AxiosResponse): Promise<{ [key: string]: Types.GetInterviewActivitiesResponse; }> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetAllInterviewActivitiesResponse.fromJS(resultData200);
        return Promise.resolve<{ [key: string]: Types.GetInterviewActivitiesResponse; }>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<{ [key: string]: Types.GetInterviewActivitiesResponse; }>(null as any);
}

/**
 * returns agent's suggestion
 * @return OK
 */
export function suggestion(config?: AxiosRequestConfig | undefined): Promise<Types.GetSuggestionResponse> {
    let url_ = getBaseUrl() + "/api/v1/agent/suggestion";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSuggestion,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSuggestion?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSuggestion(_response);
    });
}

function processSuggestion(response: AxiosResponse): Promise<Types.GetSuggestionResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetSuggestionResponse.fromJS(resultData200);
        return Promise.resolve<Types.GetSuggestionResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetSuggestionResponse>(null as any);
}

/**
 * AskQuestion
 * @param question Question
 * @return OK
 */
export function q(question: Types.QuestionRequest, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/v1/ai/q";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(question);

    let options_: AxiosRequestConfig = {
        ..._requestConfigQ,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigQ?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processQ(_response);
    });
}

function processQ(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

/**
 * GenerateSocialPost
 * @param description Description
 * @return OK
 */
export function post(description: Types.SocialPostRequest, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/v1/ai/social/post";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(description);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPost,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPost?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPost(_response);
    });
}

function processPost(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

/**
 * Speech to text
 * @param voice_response The voice file
 * @param language (optional) speech to text language
 * @return OK
 */
export function stt(voice_response: Types.FileParameter, language?: string | null | undefined, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/v1/ai/stt?";
    if (language !== undefined && language !== null)
        url_ += "language=" + encodeURIComponent("" + language) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (voice_response === null || voice_response === undefined)
        throw new Error("The parameter 'voice_response' cannot be null.");
    else
        content_.append("voice-response", voice_response.data, voice_response.fileName ? voice_response.fileName : "voice-response");

    let options_: AxiosRequestConfig = {
        ..._requestConfigStt,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigStt?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processStt(_response);
    });
}

function processStt(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

/**
 * TTS
 * @param request Request
 * @return OK
 */
export function tts(request: Types.TTSRequest, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/v1/ai/tts";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigTts,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigTts?.headers,
            "Content-Type": "application/json",
            "Accept": "application/octet-stream",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processTts(_response);
    });
}

function processTts(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

/**
 * ListAssessments
 * @param isCancelled (optional) Filter by cancellation status
 * @return OK
 */
export function assessmentGET2(isCancelled?: boolean | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ListAssessmentsResponse> {
    let url_ = getBaseUrl() + "/api/v1/assessment?";
    if (isCancelled !== undefined && isCancelled !== null)
        url_ += "isCancelled=" + encodeURIComponent("" + isCancelled) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigAssessmentGET2,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigAssessmentGET2?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAssessmentGET2(_response);
    });
}

function processAssessmentGET2(response: AxiosResponse): Promise<Types.ListAssessmentsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.ListAssessmentsResponse.fromJS(resultData200);
        return Promise.resolve<Types.ListAssessmentsResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListAssessmentsResponse>(null as any);
}

/**
 * CreateAssessment
 * @param request Request
 * @return OK
 */
export function assessmentPOST(request: Types.CreateAssessmentRequest, config?: AxiosRequestConfig | undefined): Promise<Types.CreateAssessmentResponse> {
    let url_ = getBaseUrl() + "/api/v1/assessment";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigAssessmentPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigAssessmentPOST?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAssessmentPOST(_response);
    });
}

function processAssessmentPOST(response: AxiosResponse): Promise<Types.CreateAssessmentResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.CreateAssessmentResponse.fromJS(resultData200);
        return Promise.resolve<Types.CreateAssessmentResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CreateAssessmentResponse>(null as any);
}

/**
 * ListAssessmentsPageable
 * @param isCancelled (optional) Filter by cancellation status
 * @param page (optional) Page number
 * @param pageSize (optional) Number of items per page
 * @return OK
 */
export function page(isCancelled?: boolean | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ListAssessmentsResponse> {
    let url_ = getBaseUrl() + "/api/v1/assessment/page?";
    if (isCancelled !== undefined && isCancelled !== null)
        url_ += "isCancelled=" + encodeURIComponent("" + isCancelled) + "&";
    if (page !== undefined && page !== null)
        url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize !== undefined && pageSize !== null)
        url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPage,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPage?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPage(_response);
    });
}

function processPage(response: AxiosResponse): Promise<Types.ListAssessmentsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.ListAssessmentsResponse.fromJS(resultData200);
        return Promise.resolve<Types.ListAssessmentsResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListAssessmentsResponse>(null as any);
}

/**
 * ListAssessmentTypes
 * @return OK
 */
export function typesGET(config?: AxiosRequestConfig | undefined): Promise<Types.ListAssessmentTypesResponse> {
    let url_ = getBaseUrl() + "/api/v1/assessment/types";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigTypesGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigTypesGET?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processTypesGET(_response);
    });
}

function processTypesGET(response: AxiosResponse): Promise<Types.ListAssessmentTypesResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.ListAssessmentTypesResponse.fromJS(resultData200);
        return Promise.resolve<Types.ListAssessmentTypesResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListAssessmentTypesResponse>(null as any);
}

/**
 * GetAssessment
 * @param assessmentId Assessment ID
 * @return OK
 */
export function assessmentGET3(assessmentId: number, config?: AxiosRequestConfig | undefined): Promise<Types.GetAssessmentsResponse> {
    let url_ = getBaseUrl() + "/api/v1/assessment/{assessmentId}";
    if (assessmentId === undefined || assessmentId === null)
      throw new Error("The parameter 'assessmentId' must be defined.");
    url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigAssessmentGET3,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigAssessmentGET3?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAssessmentGET3(_response);
    });
}

function processAssessmentGET3(response: AxiosResponse): Promise<Types.GetAssessmentsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetAssessmentsResponse.fromJS(resultData200);
        return Promise.resolve<Types.GetAssessmentsResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetAssessmentsResponse>(null as any);
}

/**
 * CancelAssessment
 * @param assessmentId Assessment ID
 * @return OK
 */
export function assessmentDELETE(assessmentId: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/v1/assessment/{assessmentId}";
    if (assessmentId === undefined || assessmentId === null)
      throw new Error("The parameter 'assessmentId' must be defined.");
    url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigAssessmentDELETE,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigAssessmentDELETE?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAssessmentDELETE(_response);
    });
}

function processAssessmentDELETE(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * ContinueAssessment
 * @param assessmentId Assessment ID
 * @return OK
 */
export function continue_(assessmentId: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/v1/assessment/{assessmentId}/continue";
    if (assessmentId === undefined || assessmentId === null)
      throw new Error("The parameter 'assessmentId' must be defined.");
    url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigContinue,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigContinue?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processContinue(_response);
    });
}

function processContinue(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * PauseAssessment
 * @param assessmentId Assessment ID
 * @return OK
 */
export function pause(assessmentId: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/v1/assessment/{assessmentId}/pause";
    if (assessmentId === undefined || assessmentId === null)
      throw new Error("The parameter 'assessmentId' must be defined.");
    url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPause,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPause?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPause(_response);
    });
}

function processPause(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * RespondToAssessmentText
 * @param assessmentId Assessment ID
 * @param request Request
 * @return OK
 */
export function text(assessmentId: number, request: Types.RespondToAssessmentTextRequest, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/v1/assessment/{assessmentId}/respond/text";
    if (assessmentId === undefined || assessmentId === null)
      throw new Error("The parameter 'assessmentId' must be defined.");
    url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigText,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigText?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processText(_response);
    });
}

function processText(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * RespondToAssessmentVoice
 * @param assessmentId Assessment ID
 * @param voice_response The response voice file
 * @return OK
 */
export function voice(assessmentId: number, voice_response: Types.FileParameter, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/v1/assessment/{assessmentId}/respond/voice";
    if (assessmentId === undefined || assessmentId === null)
      throw new Error("The parameter 'assessmentId' must be defined.");
    url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (voice_response === null || voice_response === undefined)
        throw new Error("The parameter 'voice_response' cannot be null.");
    else
        content_.append("voice-response", voice_response.data, voice_response.fileName ? voice_response.fileName : "voice-response");

    let options_: AxiosRequestConfig = {
        ..._requestConfigVoice,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigVoice?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processVoice(_response);
    });
}

function processVoice(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * returns user balance
 * @return OK
 */
export function balance(config?: AxiosRequestConfig | undefined): Promise<Types.GetBalanceResponse> {
    let url_ = getBaseUrl() + "/api/v1/billing/balance";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigBalance,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigBalance?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processBalance(_response);
    });
}

function processBalance(response: AxiosResponse): Promise<Types.GetBalanceResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetBalanceResponse.fromJS(resultData200);
        return Promise.resolve<Types.GetBalanceResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetBalanceResponse>(null as any);
}

/**
 * get billing settings
 * @return OK
 */
export function settingsGET(config?: AxiosRequestConfig | undefined): Promise<Types.GetBillingSettingsResponse> {
    let url_ = getBaseUrl() + "/api/v1/billing/settings";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSettingsGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSettingsGET?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSettingsGET(_response);
    });
}

function processSettingsGET(response: AxiosResponse): Promise<Types.GetBillingSettingsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetBillingSettingsResponse.fromJS(resultData200);
        return Promise.resolve<Types.GetBillingSettingsResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetBillingSettingsResponse>(null as any);
}

/**
 * update billing settings
 * @param request Request
 * @return OK
 */
export function settingsPOST(request: Types.UpdateBillingSettingsRequest, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/v1/billing/settings";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigSettingsPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSettingsPOST?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSettingsPOST(_response);
    });
}

function processSettingsPOST(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * returns spend summary
 * @return OK
 */
export function summary(config?: AxiosRequestConfig | undefined): Promise<Types.ListTransactionsResponse> {
    let url_ = getBaseUrl() + "/api/v1/billing/spend/summary";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSummary,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSummary?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSummary(_response);
    });
}

function processSummary(response: AxiosResponse): Promise<Types.ListTransactionsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.ListTransactionsResponse.fromJS(resultData200);
        return Promise.resolve<Types.ListTransactionsResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListTransactionsResponse>(null as any);
}

/**
 * top-up
 * @param request Request
 * @return OK
 */
export function topupPOST(request: Types.TopUpRequest, config?: AxiosRequestConfig | undefined): Promise<Types.TopUpResponse> {
    let url_ = getBaseUrl() + "/api/v1/billing/topup";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigTopupPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigTopupPOST?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processTopupPOST(_response);
    });
}

function processTopupPOST(response: AxiosResponse): Promise<Types.TopUpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.TopUpResponse.fromJS(resultData200);
        return Promise.resolve<Types.TopUpResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.TopUpResponse>(null as any);
}

/**
 * get top-up
 * @param id TopUpID
 * @return OK
 */
export function topupGET(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.TopUp> {
    let url_ = getBaseUrl() + "/api/v1/billing/topup/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigTopupGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigTopupGET?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processTopupGET(_response);
    });
}

function processTopupGET(response: AxiosResponse): Promise<Types.TopUp> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.TopUp.fromJS(resultData200);
        return Promise.resolve<Types.TopUp>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.TopUp>(null as any);
}

/**
 * lists transactions
 * @param transaction_type (optional) Transaction type
 * @return OK
 */
export function transactions(transaction_type?: Types.Transaction_type | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ListTransactionsResponse> {
    let url_ = getBaseUrl() + "/api/v1/billing/transactions?";
    if (transaction_type !== undefined && transaction_type !== null)
        url_ += "transaction_type=" + encodeURIComponent("" + transaction_type) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigTransactions,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigTransactions?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processTransactions(_response);
    });
}

function processTransactions(response: AxiosResponse): Promise<Types.ListTransactionsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.ListTransactionsResponse.fromJS(resultData200);
        return Promise.resolve<Types.ListTransactionsResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListTransactionsResponse>(null as any);
}

/**
 * ListTrainingCourses
 * @return OK
 */
export function courseGET2(config?: AxiosRequestConfig | undefined): Promise<Types.ListTrainingCoursesResponse> {
    let url_ = getBaseUrl() + "/api/v1/course";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigCourseGET2,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigCourseGET2?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCourseGET2(_response);
    });
}

function processCourseGET2(response: AxiosResponse): Promise<Types.ListTrainingCoursesResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.ListTrainingCoursesResponse.fromJS(resultData200);
        return Promise.resolve<Types.ListTrainingCoursesResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListTrainingCoursesResponse>(null as any);
}

/**
 * StartTrainingCourses
 * @param request Request
 * @return OK
 */
export function coursePOST(request: Types.StartTrainingCourseRequest, config?: AxiosRequestConfig | undefined): Promise<Types.StartTrainingCourseResponse> {
    let url_ = getBaseUrl() + "/api/v1/course";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCoursePOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCoursePOST?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCoursePOST(_response);
    });
}

function processCoursePOST(response: AxiosResponse): Promise<Types.StartTrainingCourseResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.StartTrainingCourseResponse.fromJS(resultData200);
        return Promise.resolve<Types.StartTrainingCourseResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.StartTrainingCourseResponse>(null as any);
}

/**
 * ListRunningCourses
 * @return OK
 */
export function list(config?: AxiosRequestConfig | undefined): Promise<Types.ListRunningCoursesResponse> {
    let url_ = getBaseUrl() + "/api/v1/course/list";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigList,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigList?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processList(_response);
    });
}

function processList(response: AxiosResponse): Promise<Types.ListRunningCoursesResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.ListRunningCoursesResponse.fromJS(resultData200);
        return Promise.resolve<Types.ListRunningCoursesResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListRunningCoursesResponse>(null as any);
}

/**
 * TrainingCoursesGenerateExample
 * @param id ID
 * @param request Request
 * @return OK
 */
export function example(id: number, request: Types.ConversationGenerateExampleRequest, config?: AxiosRequestConfig | undefined): Promise<Types.ConversationGenerateExampleResponse> {
    let url_ = getBaseUrl() + "/api/v1/course/{id}/conversation/example";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigExample,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigExample?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processExample(_response);
    });
}

function processExample(response: AxiosResponse): Promise<Types.ConversationGenerateExampleResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.ConversationGenerateExampleResponse.fromJS(resultData200);
        return Promise.resolve<Types.ConversationGenerateExampleResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ConversationGenerateExampleResponse>(null as any);
}

/**
 * TrainingCourseAskQuestion
 * @param id ID
 * @param request Request
 * @return OK
 */
export function question(id: number, request: Types.ConversationAskQuestionRequest, config?: AxiosRequestConfig | undefined): Promise<Types.ConversationAskQuestionResponse> {
    let url_ = getBaseUrl() + "/api/v1/course/{id}/conversation/question";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigQuestion,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigQuestion?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processQuestion(_response);
    });
}

function processQuestion(response: AxiosResponse): Promise<Types.ConversationAskQuestionResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.ConversationAskQuestionResponse.fromJS(resultData200);
        return Promise.resolve<Types.ConversationAskQuestionResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ConversationAskQuestionResponse>(null as any);
}

/**
 * Upload File
 * @param file File to upload (Excel, Word, PDF)
 * @return File uploaded successfully
 */
export function filesPOST(file: Types.FileParameter, config?: AxiosRequestConfig | undefined): Promise<Types.UploadFileResponse> {
    let url_ = getBaseUrl() + "/api/v1/files";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file === null || file === undefined)
        throw new Error("The parameter 'file' cannot be null.");
    else
        content_.append("file", file.data, file.fileName ? file.fileName : "file");

    let options_: AxiosRequestConfig = {
        ..._requestConfigFilesPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigFilesPOST?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processFilesPOST(_response);
    });
}

function processFilesPOST(response: AxiosResponse): Promise<Types.UploadFileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 201) {
        const _responseText = response.data;
        let result201: any = null;
        let resultData201  = _responseText;
        result201 = Types.UploadFileResponse.fromJS(resultData201);
        return Promise.resolve<Types.UploadFileResponse>(result201);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.HTTPError.fromJS(resultData400);
        return throwException("Invalid file type or missing file", status, _responseText, _headers, result400);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = Types.HTTPError.fromJS(resultData500);
        return throwException("Internal server error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.UploadFileResponse>(null as any);
}

/**
 * Get User Files
 * @param page (optional) Page number (default: 0)
 * @param pageSize (optional) Number of items per page (default: 5)
 * @param source (optional) Filter files by source (optional)
 * @param fileExt (optional) Filter files by file extension (optional)
 * @return List of user files
 */
export function user(page?: number | null | undefined, pageSize?: number | null | undefined, source?: Types.Source | null | undefined, fileExt?: string | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.GetFilesListResponse> {
    let url_ = getBaseUrl() + "/api/v1/files/user?";
    if (page !== undefined && page !== null)
        url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize !== undefined && pageSize !== null)
        url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (source !== undefined && source !== null)
        url_ += "source=" + encodeURIComponent("" + source) + "&";
    if (fileExt !== undefined && fileExt !== null)
        url_ += "fileExt=" + encodeURIComponent("" + fileExt) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigUser,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigUser?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUser(_response);
    });
}

function processUser(response: AxiosResponse): Promise<Types.GetFilesListResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetFilesListResponse.fromJS(resultData200);
        return Promise.resolve<Types.GetFilesListResponse>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.HTTPError.fromJS(resultData400);
        return throwException("Invalid source parameter", status, _responseText, _headers, result400);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = Types.HTTPError.fromJS(resultData500);
        return throwException("Internal server error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetFilesListResponse>(null as any);
}

/**
 * DownloadUserFileByFileID
 * @param fileId FileID
 * @return OK
 */
export function download(fileId: string, config?: AxiosRequestConfig | undefined): Promise<number[]> {
    let url_ = getBaseUrl() + "/api/v1/files/{fileId}/download";
    if (fileId === undefined || fileId === null)
      throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDownload,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigDownload?.headers,
            "Accept": "application/octet-stream",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDownload(_response);
    });
}

function processDownload(response: AxiosResponse): Promise<number[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(item);
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<number[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<number[]>(null as any);
}

/**
 * Download File By User And File ID
 * @param fileId File ID
 * @param userId User ID
 * @return OK
 */
export function download2(fileId: string, userId: string, config?: AxiosRequestConfig | undefined): Promise<number[]> {
    let url_ = getBaseUrl() + "/api/v1/files/{userId}/{fileId}/download";
    if (fileId === undefined || fileId === null)
      throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDownload2,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigDownload2?.headers,
            "Accept": "application/octet-stream",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDownload2(_response);
    });
}

function processDownload2(response: AxiosResponse): Promise<number[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(item);
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<number[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<number[]>(null as any);
}

/**
 * ListInterviews
 * @param categoryType (optional) Category Type
 * @param isCancelled (optional) Filter by cancellation status
 * @return OK
 */
export function interviewGET2(categoryType?: Types.CategoryType | null | undefined, isCancelled?: boolean | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ListInterviewsResponse> {
    let url_ = getBaseUrl() + "/api/v1/interview?";
    if (categoryType !== undefined && categoryType !== null)
        url_ += "categoryType=" + encodeURIComponent("" + categoryType) + "&";
    if (isCancelled !== undefined && isCancelled !== null)
        url_ += "isCancelled=" + encodeURIComponent("" + isCancelled) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigInterviewGET2,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigInterviewGET2?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processInterviewGET2(_response);
    });
}

function processInterviewGET2(response: AxiosResponse): Promise<Types.ListInterviewsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.ListInterviewsResponse.fromJS(resultData200);
        return Promise.resolve<Types.ListInterviewsResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListInterviewsResponse>(null as any);
}

/**
 * CreateInterview
 * @param request Request
 * @return OK
 */
export function interviewPOST(request: Types.CreateInterviewRequest, config?: AxiosRequestConfig | undefined): Promise<Types.CreateInterviewResponse> {
    let url_ = getBaseUrl() + "/api/v1/interview";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigInterviewPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigInterviewPOST?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processInterviewPOST(_response);
    });
}

function processInterviewPOST(response: AxiosResponse): Promise<Types.CreateInterviewResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.CreateInterviewResponse.fromJS(resultData200);
        return Promise.resolve<Types.CreateInterviewResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CreateInterviewResponse>(null as any);
}

/**
 * GetListOfInterviewCategoriesType
 * @return OK
 */
export function categoriesType(config?: AxiosRequestConfig | undefined): Promise<Types.GetListOfInterviewCategoriesType> {
    let url_ = getBaseUrl() + "/api/v1/interview/categories-type";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigCategoriesType,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigCategoriesType?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCategoriesType(_response);
    });
}

function processCategoriesType(response: AxiosResponse): Promise<Types.GetListOfInterviewCategoriesType> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetListOfInterviewCategoriesType.fromJS(resultData200);
        return Promise.resolve<Types.GetListOfInterviewCategoriesType>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetListOfInterviewCategoriesType>(null as any);
}

/**
 * Generate General Interview Types
 * @param request List of file IDs to process
 * @return Generated interview types
 */
export function generalAll(request: Types.GenerateJobInterviewTypesByFilesRequest, config?: AxiosRequestConfig | undefined): Promise<Types.InterviewType[]> {
    let url_ = getBaseUrl() + "/api/v1/interview/files/general";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigGeneralAll,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigGeneralAll?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGeneralAll(_response);
    });
}

function processGeneralAll(response: AxiosResponse): Promise<Types.InterviewType[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.InterviewType.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.InterviewType[]>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.HTTPError.fromJS(resultData400);
        return throwException("Invalid file type", status, _responseText, _headers, result400);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = Types.HTTPError.fromJS(resultData500);
        return throwException("Internal server error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.InterviewType[]>(null as any);
}

/**
 * Generate Job Interview Types
 * @param request List of file IDs to process
 * @return Generated interview types
 */
export function job(request: Types.GenerateJobInterviewTypesByFilesRequest, config?: AxiosRequestConfig | undefined): Promise<Types.InterviewType[]> {
    let url_ = getBaseUrl() + "/api/v1/interview/files/job";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigJob,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigJob?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processJob(_response);
    });
}

function processJob(response: AxiosResponse): Promise<Types.InterviewType[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.InterviewType.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.InterviewType[]>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.HTTPError.fromJS(resultData400);
        return throwException("Invalid file type", status, _responseText, _headers, result400);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = Types.HTTPError.fromJS(resultData500);
        return throwException("Internal server error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.InterviewType[]>(null as any);
}

/**
 * GenerateGeneralInterviewTypes
 * @param request Request
 * @return OK
 */
export function general(request: Types.GenerateGeneralInterviewRequest, config?: AxiosRequestConfig | undefined): Promise<Types.InterviewType> {
    let url_ = getBaseUrl() + "/api/v1/interview/generate/general";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigGeneral,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigGeneral?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGeneral(_response);
    });
}

function processGeneral(response: AxiosResponse): Promise<Types.InterviewType> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.InterviewType.fromJS(resultData200);
        return Promise.resolve<Types.InterviewType>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.InterviewType>(null as any);
}

/**
 * GenerateJobInterviewTypes
 * @param request Request
 * @return OK
 */
export function job2(request: Types.GenerateJobInterviewRequest, config?: AxiosRequestConfig | undefined): Promise<Types.InterviewType[]> {
    let url_ = getBaseUrl() + "/api/v1/interview/generate/job";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigJob2,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigJob2?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processJob2(_response);
    });
}

function processJob2(response: AxiosResponse): Promise<Types.InterviewType[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.InterviewType.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.InterviewType[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.InterviewType[]>(null as any);
}

/**
 * ListInterviewsPageable
 * @param categoryType (optional) Category Type
 * @param isCancelled (optional) Filter by cancellation status
 * @param page (optional) Page number
 * @param pageSize (optional) Number of items per page
 * @return OK
 */
export function page2(categoryType?: Types.CategoryType2 | null | undefined, isCancelled?: boolean | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ListInterviewsResponse> {
    let url_ = getBaseUrl() + "/api/v1/interview/page?";
    if (categoryType !== undefined && categoryType !== null)
        url_ += "categoryType=" + encodeURIComponent("" + categoryType) + "&";
    if (isCancelled !== undefined && isCancelled !== null)
        url_ += "isCancelled=" + encodeURIComponent("" + isCancelled) + "&";
    if (page !== undefined && page !== null)
        url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize !== undefined && pageSize !== null)
        url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPage2,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPage2?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPage2(_response);
    });
}

function processPage2(response: AxiosResponse): Promise<Types.ListInterviewsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.ListInterviewsResponse.fromJS(resultData200);
        return Promise.resolve<Types.ListInterviewsResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListInterviewsResponse>(null as any);
}

/**
 * RequestInterviewTypes
 * @param request Request
 * @return OK
 */
export function request(request: Types.RequestInterviewRequest, config?: AxiosRequestConfig | undefined): Promise<Types.RequestInterviewResponse> {
    let url_ = getBaseUrl() + "/api/v1/interview/request";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigRequest,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigRequest?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRequest(_response);
    });
}

function processRequest(response: AxiosResponse): Promise<Types.RequestInterviewResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.RequestInterviewResponse.fromJS(resultData200);
        return Promise.resolve<Types.RequestInterviewResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RequestInterviewResponse>(null as any);
}

/**
 * ListInterviewTypes
 * @param categoryType (optional) Category Type
 * @return OK
 */
export function typesGET2(categoryType?: Types.CategoryType3 | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ListInterviewTypesResponse> {
    let url_ = getBaseUrl() + "/api/v1/interview/types?";
    if (categoryType !== undefined && categoryType !== null)
        url_ += "categoryType=" + encodeURIComponent("" + categoryType) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigTypesGET2,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigTypesGET2?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processTypesGET2(_response);
    });
}

function processTypesGET2(response: AxiosResponse): Promise<Types.ListInterviewTypesResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.ListInterviewTypesResponse.fromJS(resultData200);
        return Promise.resolve<Types.ListInterviewTypesResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListInterviewTypesResponse>(null as any);
}

/**
 * DeleteInterviewType
 * @param interviewTypeId Interview type id
 * @return OK
 */
export function typesDELETE(interviewTypeId: string, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/v1/interview/types/{interviewTypeId}";
    if (interviewTypeId === undefined || interviewTypeId === null)
      throw new Error("The parameter 'interviewTypeId' must be defined.");
    url_ = url_.replace("{interviewTypeId}", encodeURIComponent("" + interviewTypeId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigTypesDELETE,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigTypesDELETE?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processTypesDELETE(_response);
    });
}

function processTypesDELETE(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * GetInterview
 * @param interviewId Interview ID
 * @return OK
 */
export function interviewGET3(interviewId: number, config?: AxiosRequestConfig | undefined): Promise<Types.GetInterviewsResponse> {
    let url_ = getBaseUrl() + "/api/v1/interview/{interviewId}";
    if (interviewId === undefined || interviewId === null)
      throw new Error("The parameter 'interviewId' must be defined.");
    url_ = url_.replace("{interviewId}", encodeURIComponent("" + interviewId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigInterviewGET3,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigInterviewGET3?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processInterviewGET3(_response);
    });
}

function processInterviewGET3(response: AxiosResponse): Promise<Types.GetInterviewsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetInterviewsResponse.fromJS(resultData200);
        return Promise.resolve<Types.GetInterviewsResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetInterviewsResponse>(null as any);
}

/**
 * CancelInterview
 * @param interviewId Interview ID
 * @return OK
 */
export function interviewDELETE(interviewId: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/v1/interview/{interviewId}";
    if (interviewId === undefined || interviewId === null)
      throw new Error("The parameter 'interviewId' must be defined.");
    url_ = url_.replace("{interviewId}", encodeURIComponent("" + interviewId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigInterviewDELETE,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigInterviewDELETE?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processInterviewDELETE(_response);
    });
}

function processInterviewDELETE(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * ContinueInterview
 * @param interviewId Interview ID
 * @return OK
 */
export function continue2(interviewId: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/v1/interview/{interviewId}/continue";
    if (interviewId === undefined || interviewId === null)
      throw new Error("The parameter 'interviewId' must be defined.");
    url_ = url_.replace("{interviewId}", encodeURIComponent("" + interviewId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigContinue2,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigContinue2?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processContinue2(_response);
    });
}

function processContinue2(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * PauseInterview
 * @param interviewId Interview ID
 * @return OK
 */
export function pause2(interviewId: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/v1/interview/{interviewId}/pause";
    if (interviewId === undefined || interviewId === null)
      throw new Error("The parameter 'interviewId' must be defined.");
    url_ = url_.replace("{interviewId}", encodeURIComponent("" + interviewId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPause2,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPause2?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPause2(_response);
    });
}

function processPause2(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * RespondToInterviewText
 * @param interviewId Interview ID
 * @param request Request
 * @return OK
 */
export function text2(interviewId: number, request: Types.RespondToInterviewTextRequest, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/v1/interview/{interviewId}/respond/text";
    if (interviewId === undefined || interviewId === null)
      throw new Error("The parameter 'interviewId' must be defined.");
    url_ = url_.replace("{interviewId}", encodeURIComponent("" + interviewId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigText2,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigText2?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processText2(_response);
    });
}

function processText2(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * RespondToInterviewVoice
 * @param interviewId Interview ID
 * @param voice_response The response voice file
 * @return OK
 */
export function voice2(interviewId: number, voice_response: Types.FileParameter, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/v1/interview/{interviewId}/respond/voice";
    if (interviewId === undefined || interviewId === null)
      throw new Error("The parameter 'interviewId' must be defined.");
    url_ = url_.replace("{interviewId}", encodeURIComponent("" + interviewId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (voice_response === null || voice_response === undefined)
        throw new Error("The parameter 'voice_response' cannot be null.");
    else
        content_.append("voice-response", voice_response.data, voice_response.fileName ? voice_response.fileName : "voice-response");

    let options_: AxiosRequestConfig = {
        ..._requestConfigVoice2,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigVoice2?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processVoice2(_response);
    });
}

function processVoice2(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Jobs
 * @return OK
 */
export function jobs(config?: AxiosRequestConfig | undefined): Promise<Types.JobsResponse> {
    let url_ = getBaseUrl() + "/api/v1/jobs";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigJobs,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigJobs?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processJobs(_response);
    });
}

function processJobs(response: AxiosResponse): Promise<Types.JobsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.JobsResponse.fromJS(resultData200);
        return Promise.resolve<Types.JobsResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.JobsResponse>(null as any);
}

/**
 * LoginByResume
 * @param file The file
 * @return OK
 */
export function resume(file: Types.FileParameter, config?: AxiosRequestConfig | undefined): Promise<Types.LoginByResumeResponse> {
    let url_ = getBaseUrl() + "/api/v1/login/resume";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file === null || file === undefined)
        throw new Error("The parameter 'file' cannot be null.");
    else
        content_.append("file", file.data, file.fileName ? file.fileName : "file");

    let options_: AxiosRequestConfig = {
        ..._requestConfigResume,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigResume?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processResume(_response);
    });
}

function processResume(response: AxiosResponse): Promise<Types.LoginByResumeResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.LoginByResumeResponse.fromJS(resultData200);
        return Promise.resolve<Types.LoginByResumeResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.LoginByResumeResponse>(null as any);
}

/**
 * describe user
 * @return OK
 */
export function aboutMe(config?: AxiosRequestConfig | undefined): Promise<Types.DescribeResponse> {
    let url_ = getBaseUrl() + "/api/v1/profile/describe/about-me";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigAboutMe,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigAboutMe?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAboutMe(_response);
    });
}

function processAboutMe(response: AxiosResponse): Promise<Types.DescribeResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.DescribeResponse.fromJS(resultData200);
        return Promise.resolve<Types.DescribeResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DescribeResponse>(null as any);
}

/**
 * describe user's projects
 * @param request Request
 * @return OK
 */
export function projects(request: Types.Project, config?: AxiosRequestConfig | undefined): Promise<Types.DescribeResponse> {
    let url_ = getBaseUrl() + "/api/v1/profile/describe/projects";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigProjects,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigProjects?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processProjects(_response);
    });
}

function processProjects(response: AxiosResponse): Promise<Types.DescribeResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.DescribeResponse.fromJS(resultData200);
        return Promise.resolve<Types.DescribeResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DescribeResponse>(null as any);
}

/**
 * describe user's work experience
 * @param request Request
 * @return OK
 */
export function workExperience(request: Types.Experience, config?: AxiosRequestConfig | undefined): Promise<Types.DescribeResponse> {
    let url_ = getBaseUrl() + "/api/v1/profile/describe/work-experience";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigWorkExperience,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigWorkExperience?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processWorkExperience(_response);
    });
}

function processWorkExperience(response: AxiosResponse): Promise<Types.DescribeResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.DescribeResponse.fromJS(resultData200);
        return Promise.resolve<Types.DescribeResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DescribeResponse>(null as any);
}

/**
 * UpdateByResume
 * @param file The file
 * @return OK
 */
export function resume2(file: Types.FileParameter, config?: AxiosRequestConfig | undefined): Promise<Types.UserDetails> {
    let url_ = getBaseUrl() + "/api/v1/profile/resume";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file === null || file === undefined)
        throw new Error("The parameter 'file' cannot be null.");
    else
        content_.append("file", file.data, file.fileName ? file.fileName : "file");

    let options_: AxiosRequestConfig = {
        ..._requestConfigResume2,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigResume2?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processResume2(_response);
    });
}

function processResume2(response: AxiosResponse): Promise<Types.UserDetails> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.UserDetails.fromJS(resultData200);
        return Promise.resolve<Types.UserDetails>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.UserDetails>(null as any);
}

/**
 * suggests skills for the provided description
 * @param request Request
 * @return OK
 */
export function description(request: Types.SkillBasedOnDescriptionRequest, config?: AxiosRequestConfig | undefined): Promise<Types.SkillBasedOnDescriptionResponse> {
    let url_ = getBaseUrl() + "/api/v1/profile/skills/description";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigDescription,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigDescription?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDescription(_response);
    });
}

function processDescription(response: AxiosResponse): Promise<Types.SkillBasedOnDescriptionResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.SkillBasedOnDescriptionResponse.fromJS(resultData200);
        return Promise.resolve<Types.SkillBasedOnDescriptionResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SkillBasedOnDescriptionResponse>(null as any);
}

/**
 * suggests new skills for the user to add to his list of skills
 * @return OK
 */
export function graph2(config?: AxiosRequestConfig | undefined): Promise<Types.GetSkillScoreGraphResponse> {
    let url_ = getBaseUrl() + "/api/v1/profile/skills/score/graph";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGraph2,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGraph2?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGraph2(_response);
    });
}

function processGraph2(response: AxiosResponse): Promise<Types.GetSkillScoreGraphResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetSkillScoreGraphResponse.fromJS(resultData200);
        return Promise.resolve<Types.GetSkillScoreGraphResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetSkillScoreGraphResponse>(null as any);
}

/**
 * suggests new skills for the user to add to his list of skills
 * @return OK
 */
export function suggest(config?: AxiosRequestConfig | undefined): Promise<Types.SuggestNewSkillsResponse> {
    let url_ = getBaseUrl() + "/api/v1/profile/skills/suggest";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSuggest,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSuggest?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSuggest(_response);
    });
}

function processSuggest(response: AxiosResponse): Promise<Types.SuggestNewSkillsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.SuggestNewSkillsResponse.fromJS(resultData200);
        return Promise.resolve<Types.SuggestNewSkillsResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SuggestNewSkillsResponse>(null as any);
}

/**
 * suggests new certificates for the user to get
 * @return OK
 */
export function certificates(config?: AxiosRequestConfig | undefined): Promise<Types.SuggestNewCertificatesResponse> {
    let url_ = getBaseUrl() + "/api/v1/profile/suggest/certificates";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigCertificates,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCertificates?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCertificates(_response);
    });
}

function processCertificates(response: AxiosResponse): Promise<Types.SuggestNewCertificatesResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.SuggestNewCertificatesResponse.fromJS(resultData200);
        return Promise.resolve<Types.SuggestNewCertificatesResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SuggestNewCertificatesResponse>(null as any);
}

/**
 * SignUpEmail
 * @param request Request
 * @return OK
 */
export function email(request: Types.SignUpEmailRequest, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/v1/signup/email";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigEmail,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigEmail?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processEmail(_response);
    });
}

function processEmail(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * SignUpPassword
 * @param request Request
 * @return OK
 */
export function password(request: Types.SignUpPasswordRequest, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/v1/signup/password";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPassword,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPassword?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPassword(_response);
    });
}

function processPassword(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Get User Files
 * @param page (optional) Page number (default: 0)
 * @param pageSize (optional) Number of items per page (default: 5)
 * @param source (optional) Filter files by source (optional)
 * @param fileExt (optional) Filter files by file extension (optional)
 * @return List of user files
 */
export function filesGET(page?: number | null | undefined, pageSize?: number | null | undefined, source?: Types.Source2 | null | undefined, fileExt?: string | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.GetUserFilesListResponse> {
    let url_ = getBaseUrl() + "/api/v1/user/files?";
    if (page !== undefined && page !== null)
        url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize !== undefined && pageSize !== null)
        url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (source !== undefined && source !== null)
        url_ += "source=" + encodeURIComponent("" + source) + "&";
    if (fileExt !== undefined && fileExt !== null)
        url_ += "fileExt=" + encodeURIComponent("" + fileExt) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigFilesGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigFilesGET?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processFilesGET(_response);
    });
}

function processFilesGET(response: AxiosResponse): Promise<Types.GetUserFilesListResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetUserFilesListResponse.fromJS(resultData200);
        return Promise.resolve<Types.GetUserFilesListResponse>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.HTTPError.fromJS(resultData400);
        return throwException("Invalid source parameter", status, _responseText, _headers, result400);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = Types.HTTPError.fromJS(resultData500);
        return throwException("Internal server error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetUserFilesListResponse>(null as any);
}

/**
 * UploadUserFile
 * @param file The file
 * @return OK
 */
export function filesPUT(file: Types.FileParameter, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/v1/user/files";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file === null || file === undefined)
        throw new Error("The parameter 'file' cannot be null.");
    else
        content_.append("file", file.data, file.fileName ? file.fileName : "file");

    let options_: AxiosRequestConfig = {
        ..._requestConfigFilesPUT,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigFilesPUT?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processFilesPUT(_response);
    });
}

function processFilesPUT(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

/**
 * Upload User File Stream
 * @param file The file
 * @return OK
 */
export function stream(file: Types.FileParameter, config?: AxiosRequestConfig | undefined): Promise<Types.UploadFileStreamResponse> {
    let url_ = getBaseUrl() + "/api/v1/user/files/stream";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file === null || file === undefined)
        throw new Error("The parameter 'file' cannot be null.");
    else
        content_.append("file", file.data, file.fileName ? file.fileName : "file");

    let options_: AxiosRequestConfig = {
        ..._requestConfigStream,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigStream?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processStream(_response);
    });
}

function processStream(response: AxiosResponse): Promise<Types.UploadFileStreamResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.UploadFileStreamResponse.fromJS(resultData200);
        return Promise.resolve<Types.UploadFileStreamResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.UploadFileStreamResponse>(null as any);
}

/**
 * DownloadUserFile
 * @param fileId FileID
 * @return OK
 */
export function download3(fileId: string, config?: AxiosRequestConfig | undefined): Promise<number[]> {
    let url_ = getBaseUrl() + "/api/v1/user/files/{fileId}/download";
    if (fileId === undefined || fileId === null)
      throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDownload3,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigDownload3?.headers,
            "Accept": "application/octet-stream",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDownload3(_response);
    });
}

function processDownload3(response: AxiosResponse): Promise<number[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(item);
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<number[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<number[]>(null as any);
}

/**
 * DownloadFile
 * @param fileId FileID
 * @return OK
 */
export function download4(fileId: string, config?: AxiosRequestConfig | undefined): Promise<number[]> {
    let url_ = getBaseUrl() + "/api/v1/user/files/{userId}/{fileId}/download";
    if (fileId === undefined || fileId === null)
      throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDownload4,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigDownload4?.headers,
            "Accept": "application/octet-stream",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDownload4(_response);
    });
}

function processDownload4(response: AxiosResponse): Promise<number[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(item);
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<number[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<number[]>(null as any);
}

/**
 * ForgetPassword
 * @param request Request
 * @return OK
 */
export function forget(request: Types.SignUpEmailRequest, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/v1/user/forget";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigForget,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigForget?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processForget(_response);
    });
}

function processForget(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * GetMe
 * @return OK
 */
export function meGET(config?: AxiosRequestConfig | undefined): Promise<Types.GetMeResponse> {
    let url_ = getBaseUrl() + "/api/v1/user/me";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigMeGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigMeGET?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processMeGET(_response);
    });
}

function processMeGET(response: AxiosResponse): Promise<Types.GetMeResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetMeResponse.fromJS(resultData200);
        return Promise.resolve<Types.GetMeResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetMeResponse>(null as any);
}

/**
 * UpdateMe
 * @param request Request
 * @return OK
 */
export function mePOST(request: Types.UpdateMeRequest, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/v1/user/me";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigMePOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigMePOST?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processMePOST(_response);
    });
}

function processMePOST(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * DeleteAccount
 * @return OK
 */
export function meDELETE(config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/v1/user/me";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigMeDELETE,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigMeDELETE?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processMeDELETE(_response);
    });
}

function processMeDELETE(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * ChangePassword
 * @param request Request
 * @return OK
 */
export function password2(request: Types.ChangePasswordRequest, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/v1/user/password";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPassword2,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPassword2?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPassword2(_response);
    });
}

function processPassword2(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * RegisterWS
 * @param request Request
 * @return OK
 */
export function ws(request: Types.RequestMessage, config?: AxiosRequestConfig | undefined): Promise<Types.ResponseMessage> {
    let url_ = getBaseUrl() + "/api/v1/ws";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigWs,
        ...config,
        data: content_,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigWs?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processWs(_response);
    });
}

function processWs(response: AxiosResponse): Promise<Types.ResponseMessage> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.ResponseMessage.fromJS(resultData200);
        return Promise.resolve<Types.ResponseMessage>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ResponseMessage>(null as any);
}
let _requestConfigAssessmentGET: Partial<AxiosRequestConfig> | undefined;
export function getAssessmentGETRequestConfig() {
  return _requestConfigAssessmentGET;
}
export function setAssessmentGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAssessmentGET = value;
}
export function patchAssessmentGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAssessmentGET = patch(_requestConfigAssessmentGET ?? {});
}

let _requestConfigCourseGET: Partial<AxiosRequestConfig> | undefined;
export function getCourseGETRequestConfig() {
  return _requestConfigCourseGET;
}
export function setCourseGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCourseGET = value;
}
export function patchCourseGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCourseGET = patch(_requestConfigCourseGET ?? {});
}

let _requestConfigGraph: Partial<AxiosRequestConfig> | undefined;
export function getGraphRequestConfig() {
  return _requestConfigGraph;
}
export function setGraphRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGraph = value;
}
export function patchGraphRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGraph = patch(_requestConfigGraph ?? {});
}

let _requestConfigInterviewGET: Partial<AxiosRequestConfig> | undefined;
export function getInterviewGETRequestConfig() {
  return _requestConfigInterviewGET;
}
export function setInterviewGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigInterviewGET = value;
}
export function patchInterviewGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigInterviewGET = patch(_requestConfigInterviewGET ?? {});
}

let _requestConfigAll: Partial<AxiosRequestConfig> | undefined;
export function getAllRequestConfig() {
  return _requestConfigAll;
}
export function setAllRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAll = value;
}
export function patchAllRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAll = patch(_requestConfigAll ?? {});
}

let _requestConfigSuggestion: Partial<AxiosRequestConfig> | undefined;
export function getSuggestionRequestConfig() {
  return _requestConfigSuggestion;
}
export function setSuggestionRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSuggestion = value;
}
export function patchSuggestionRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSuggestion = patch(_requestConfigSuggestion ?? {});
}

let _requestConfigQ: Partial<AxiosRequestConfig> | undefined;
export function getQRequestConfig() {
  return _requestConfigQ;
}
export function setQRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigQ = value;
}
export function patchQRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigQ = patch(_requestConfigQ ?? {});
}

let _requestConfigPost: Partial<AxiosRequestConfig> | undefined;
export function getPostRequestConfig() {
  return _requestConfigPost;
}
export function setPostRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPost = value;
}
export function patchPostRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPost = patch(_requestConfigPost ?? {});
}

let _requestConfigStt: Partial<AxiosRequestConfig> | undefined;
export function getSttRequestConfig() {
  return _requestConfigStt;
}
export function setSttRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigStt = value;
}
export function patchSttRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigStt = patch(_requestConfigStt ?? {});
}

let _requestConfigTts: Partial<AxiosRequestConfig> | undefined;
export function getTtsRequestConfig() {
  return _requestConfigTts;
}
export function setTtsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigTts = value;
}
export function patchTtsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigTts = patch(_requestConfigTts ?? {});
}

let _requestConfigAssessmentGET2: Partial<AxiosRequestConfig> | undefined;
export function getAssessmentGET2RequestConfig() {
  return _requestConfigAssessmentGET2;
}
export function setAssessmentGET2RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAssessmentGET2 = value;
}
export function patchAssessmentGET2RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAssessmentGET2 = patch(_requestConfigAssessmentGET2 ?? {});
}

let _requestConfigAssessmentPOST: Partial<AxiosRequestConfig> | undefined;
export function getAssessmentPOSTRequestConfig() {
  return _requestConfigAssessmentPOST;
}
export function setAssessmentPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAssessmentPOST = value;
}
export function patchAssessmentPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAssessmentPOST = patch(_requestConfigAssessmentPOST ?? {});
}

let _requestConfigPage: Partial<AxiosRequestConfig> | undefined;
export function getPageRequestConfig() {
  return _requestConfigPage;
}
export function setPageRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPage = value;
}
export function patchPageRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPage = patch(_requestConfigPage ?? {});
}

let _requestConfigTypesGET: Partial<AxiosRequestConfig> | undefined;
export function getTypesGETRequestConfig() {
  return _requestConfigTypesGET;
}
export function setTypesGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigTypesGET = value;
}
export function patchTypesGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigTypesGET = patch(_requestConfigTypesGET ?? {});
}

let _requestConfigAssessmentGET3: Partial<AxiosRequestConfig> | undefined;
export function getAssessmentGET3RequestConfig() {
  return _requestConfigAssessmentGET3;
}
export function setAssessmentGET3RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAssessmentGET3 = value;
}
export function patchAssessmentGET3RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAssessmentGET3 = patch(_requestConfigAssessmentGET3 ?? {});
}

let _requestConfigAssessmentDELETE: Partial<AxiosRequestConfig> | undefined;
export function getAssessmentDELETERequestConfig() {
  return _requestConfigAssessmentDELETE;
}
export function setAssessmentDELETERequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAssessmentDELETE = value;
}
export function patchAssessmentDELETERequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAssessmentDELETE = patch(_requestConfigAssessmentDELETE ?? {});
}

let _requestConfigContinue: Partial<AxiosRequestConfig> | undefined;
export function getContinueRequestConfig() {
  return _requestConfigContinue;
}
export function setContinueRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigContinue = value;
}
export function patchContinueRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigContinue = patch(_requestConfigContinue ?? {});
}

let _requestConfigPause: Partial<AxiosRequestConfig> | undefined;
export function getPauseRequestConfig() {
  return _requestConfigPause;
}
export function setPauseRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPause = value;
}
export function patchPauseRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPause = patch(_requestConfigPause ?? {});
}

let _requestConfigText: Partial<AxiosRequestConfig> | undefined;
export function getTextRequestConfig() {
  return _requestConfigText;
}
export function setTextRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigText = value;
}
export function patchTextRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigText = patch(_requestConfigText ?? {});
}

let _requestConfigVoice: Partial<AxiosRequestConfig> | undefined;
export function getVoiceRequestConfig() {
  return _requestConfigVoice;
}
export function setVoiceRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigVoice = value;
}
export function patchVoiceRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigVoice = patch(_requestConfigVoice ?? {});
}

let _requestConfigBalance: Partial<AxiosRequestConfig> | undefined;
export function getBalanceRequestConfig() {
  return _requestConfigBalance;
}
export function setBalanceRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigBalance = value;
}
export function patchBalanceRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigBalance = patch(_requestConfigBalance ?? {});
}

let _requestConfigSettingsGET: Partial<AxiosRequestConfig> | undefined;
export function getSettingsGETRequestConfig() {
  return _requestConfigSettingsGET;
}
export function setSettingsGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSettingsGET = value;
}
export function patchSettingsGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSettingsGET = patch(_requestConfigSettingsGET ?? {});
}

let _requestConfigSettingsPOST: Partial<AxiosRequestConfig> | undefined;
export function getSettingsPOSTRequestConfig() {
  return _requestConfigSettingsPOST;
}
export function setSettingsPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSettingsPOST = value;
}
export function patchSettingsPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSettingsPOST = patch(_requestConfigSettingsPOST ?? {});
}

let _requestConfigSummary: Partial<AxiosRequestConfig> | undefined;
export function getSummaryRequestConfig() {
  return _requestConfigSummary;
}
export function setSummaryRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSummary = value;
}
export function patchSummaryRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSummary = patch(_requestConfigSummary ?? {});
}

let _requestConfigTopupPOST: Partial<AxiosRequestConfig> | undefined;
export function getTopupPOSTRequestConfig() {
  return _requestConfigTopupPOST;
}
export function setTopupPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigTopupPOST = value;
}
export function patchTopupPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigTopupPOST = patch(_requestConfigTopupPOST ?? {});
}

let _requestConfigTopupGET: Partial<AxiosRequestConfig> | undefined;
export function getTopupGETRequestConfig() {
  return _requestConfigTopupGET;
}
export function setTopupGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigTopupGET = value;
}
export function patchTopupGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigTopupGET = patch(_requestConfigTopupGET ?? {});
}

let _requestConfigTransactions: Partial<AxiosRequestConfig> | undefined;
export function getTransactionsRequestConfig() {
  return _requestConfigTransactions;
}
export function setTransactionsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigTransactions = value;
}
export function patchTransactionsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigTransactions = patch(_requestConfigTransactions ?? {});
}

let _requestConfigCourseGET2: Partial<AxiosRequestConfig> | undefined;
export function getCourseGET2RequestConfig() {
  return _requestConfigCourseGET2;
}
export function setCourseGET2RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCourseGET2 = value;
}
export function patchCourseGET2RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCourseGET2 = patch(_requestConfigCourseGET2 ?? {});
}

let _requestConfigCoursePOST: Partial<AxiosRequestConfig> | undefined;
export function getCoursePOSTRequestConfig() {
  return _requestConfigCoursePOST;
}
export function setCoursePOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCoursePOST = value;
}
export function patchCoursePOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCoursePOST = patch(_requestConfigCoursePOST ?? {});
}

let _requestConfigList: Partial<AxiosRequestConfig> | undefined;
export function getListRequestConfig() {
  return _requestConfigList;
}
export function setListRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigList = value;
}
export function patchListRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigList = patch(_requestConfigList ?? {});
}

let _requestConfigExample: Partial<AxiosRequestConfig> | undefined;
export function getExampleRequestConfig() {
  return _requestConfigExample;
}
export function setExampleRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigExample = value;
}
export function patchExampleRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigExample = patch(_requestConfigExample ?? {});
}

let _requestConfigQuestion: Partial<AxiosRequestConfig> | undefined;
export function getQuestionRequestConfig() {
  return _requestConfigQuestion;
}
export function setQuestionRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigQuestion = value;
}
export function patchQuestionRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigQuestion = patch(_requestConfigQuestion ?? {});
}

let _requestConfigFilesPOST: Partial<AxiosRequestConfig> | undefined;
export function getFilesPOSTRequestConfig() {
  return _requestConfigFilesPOST;
}
export function setFilesPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigFilesPOST = value;
}
export function patchFilesPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigFilesPOST = patch(_requestConfigFilesPOST ?? {});
}

let _requestConfigUser: Partial<AxiosRequestConfig> | undefined;
export function getUserRequestConfig() {
  return _requestConfigUser;
}
export function setUserRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUser = value;
}
export function patchUserRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUser = patch(_requestConfigUser ?? {});
}

let _requestConfigDownload: Partial<AxiosRequestConfig> | undefined;
export function getDownloadRequestConfig() {
  return _requestConfigDownload;
}
export function setDownloadRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDownload = value;
}
export function patchDownloadRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDownload = patch(_requestConfigDownload ?? {});
}

let _requestConfigDownload2: Partial<AxiosRequestConfig> | undefined;
export function getDownload2RequestConfig() {
  return _requestConfigDownload2;
}
export function setDownload2RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDownload2 = value;
}
export function patchDownload2RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDownload2 = patch(_requestConfigDownload2 ?? {});
}

let _requestConfigInterviewGET2: Partial<AxiosRequestConfig> | undefined;
export function getInterviewGET2RequestConfig() {
  return _requestConfigInterviewGET2;
}
export function setInterviewGET2RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigInterviewGET2 = value;
}
export function patchInterviewGET2RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigInterviewGET2 = patch(_requestConfigInterviewGET2 ?? {});
}

let _requestConfigInterviewPOST: Partial<AxiosRequestConfig> | undefined;
export function getInterviewPOSTRequestConfig() {
  return _requestConfigInterviewPOST;
}
export function setInterviewPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigInterviewPOST = value;
}
export function patchInterviewPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigInterviewPOST = patch(_requestConfigInterviewPOST ?? {});
}

let _requestConfigCategoriesType: Partial<AxiosRequestConfig> | undefined;
export function getCategoriesTypeRequestConfig() {
  return _requestConfigCategoriesType;
}
export function setCategoriesTypeRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCategoriesType = value;
}
export function patchCategoriesTypeRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCategoriesType = patch(_requestConfigCategoriesType ?? {});
}

let _requestConfigGeneralAll: Partial<AxiosRequestConfig> | undefined;
export function getGeneralAllRequestConfig() {
  return _requestConfigGeneralAll;
}
export function setGeneralAllRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGeneralAll = value;
}
export function patchGeneralAllRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGeneralAll = patch(_requestConfigGeneralAll ?? {});
}

let _requestConfigJob: Partial<AxiosRequestConfig> | undefined;
export function getJobRequestConfig() {
  return _requestConfigJob;
}
export function setJobRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigJob = value;
}
export function patchJobRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigJob = patch(_requestConfigJob ?? {});
}

let _requestConfigGeneral: Partial<AxiosRequestConfig> | undefined;
export function getGeneralRequestConfig() {
  return _requestConfigGeneral;
}
export function setGeneralRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGeneral = value;
}
export function patchGeneralRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGeneral = patch(_requestConfigGeneral ?? {});
}

let _requestConfigJob2: Partial<AxiosRequestConfig> | undefined;
export function getJob2RequestConfig() {
  return _requestConfigJob2;
}
export function setJob2RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigJob2 = value;
}
export function patchJob2RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigJob2 = patch(_requestConfigJob2 ?? {});
}

let _requestConfigPage2: Partial<AxiosRequestConfig> | undefined;
export function getPage2RequestConfig() {
  return _requestConfigPage2;
}
export function setPage2RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPage2 = value;
}
export function patchPage2RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPage2 = patch(_requestConfigPage2 ?? {});
}

let _requestConfigRequest: Partial<AxiosRequestConfig> | undefined;
export function getRequestRequestConfig() {
  return _requestConfigRequest;
}
export function setRequestRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRequest = value;
}
export function patchRequestRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRequest = patch(_requestConfigRequest ?? {});
}

let _requestConfigTypesGET2: Partial<AxiosRequestConfig> | undefined;
export function getTypesGET2RequestConfig() {
  return _requestConfigTypesGET2;
}
export function setTypesGET2RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigTypesGET2 = value;
}
export function patchTypesGET2RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigTypesGET2 = patch(_requestConfigTypesGET2 ?? {});
}

let _requestConfigTypesDELETE: Partial<AxiosRequestConfig> | undefined;
export function getTypesDELETERequestConfig() {
  return _requestConfigTypesDELETE;
}
export function setTypesDELETERequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigTypesDELETE = value;
}
export function patchTypesDELETERequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigTypesDELETE = patch(_requestConfigTypesDELETE ?? {});
}

let _requestConfigInterviewGET3: Partial<AxiosRequestConfig> | undefined;
export function getInterviewGET3RequestConfig() {
  return _requestConfigInterviewGET3;
}
export function setInterviewGET3RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigInterviewGET3 = value;
}
export function patchInterviewGET3RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigInterviewGET3 = patch(_requestConfigInterviewGET3 ?? {});
}

let _requestConfigInterviewDELETE: Partial<AxiosRequestConfig> | undefined;
export function getInterviewDELETERequestConfig() {
  return _requestConfigInterviewDELETE;
}
export function setInterviewDELETERequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigInterviewDELETE = value;
}
export function patchInterviewDELETERequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigInterviewDELETE = patch(_requestConfigInterviewDELETE ?? {});
}

let _requestConfigContinue2: Partial<AxiosRequestConfig> | undefined;
export function getContinue2RequestConfig() {
  return _requestConfigContinue2;
}
export function setContinue2RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigContinue2 = value;
}
export function patchContinue2RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigContinue2 = patch(_requestConfigContinue2 ?? {});
}

let _requestConfigPause2: Partial<AxiosRequestConfig> | undefined;
export function getPause2RequestConfig() {
  return _requestConfigPause2;
}
export function setPause2RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPause2 = value;
}
export function patchPause2RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPause2 = patch(_requestConfigPause2 ?? {});
}

let _requestConfigText2: Partial<AxiosRequestConfig> | undefined;
export function getText2RequestConfig() {
  return _requestConfigText2;
}
export function setText2RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigText2 = value;
}
export function patchText2RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigText2 = patch(_requestConfigText2 ?? {});
}

let _requestConfigVoice2: Partial<AxiosRequestConfig> | undefined;
export function getVoice2RequestConfig() {
  return _requestConfigVoice2;
}
export function setVoice2RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigVoice2 = value;
}
export function patchVoice2RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigVoice2 = patch(_requestConfigVoice2 ?? {});
}

let _requestConfigJobs: Partial<AxiosRequestConfig> | undefined;
export function getJobsRequestConfig() {
  return _requestConfigJobs;
}
export function setJobsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigJobs = value;
}
export function patchJobsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigJobs = patch(_requestConfigJobs ?? {});
}

let _requestConfigResume: Partial<AxiosRequestConfig> | undefined;
export function getResumeRequestConfig() {
  return _requestConfigResume;
}
export function setResumeRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigResume = value;
}
export function patchResumeRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigResume = patch(_requestConfigResume ?? {});
}

let _requestConfigAboutMe: Partial<AxiosRequestConfig> | undefined;
export function getAboutMeRequestConfig() {
  return _requestConfigAboutMe;
}
export function setAboutMeRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAboutMe = value;
}
export function patchAboutMeRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAboutMe = patch(_requestConfigAboutMe ?? {});
}

let _requestConfigProjects: Partial<AxiosRequestConfig> | undefined;
export function getProjectsRequestConfig() {
  return _requestConfigProjects;
}
export function setProjectsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigProjects = value;
}
export function patchProjectsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigProjects = patch(_requestConfigProjects ?? {});
}

let _requestConfigWorkExperience: Partial<AxiosRequestConfig> | undefined;
export function getWorkExperienceRequestConfig() {
  return _requestConfigWorkExperience;
}
export function setWorkExperienceRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigWorkExperience = value;
}
export function patchWorkExperienceRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigWorkExperience = patch(_requestConfigWorkExperience ?? {});
}

let _requestConfigResume2: Partial<AxiosRequestConfig> | undefined;
export function getResume2RequestConfig() {
  return _requestConfigResume2;
}
export function setResume2RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigResume2 = value;
}
export function patchResume2RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigResume2 = patch(_requestConfigResume2 ?? {});
}

let _requestConfigDescription: Partial<AxiosRequestConfig> | undefined;
export function getDescriptionRequestConfig() {
  return _requestConfigDescription;
}
export function setDescriptionRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDescription = value;
}
export function patchDescriptionRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDescription = patch(_requestConfigDescription ?? {});
}

let _requestConfigGraph2: Partial<AxiosRequestConfig> | undefined;
export function getGraph2RequestConfig() {
  return _requestConfigGraph2;
}
export function setGraph2RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGraph2 = value;
}
export function patchGraph2RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGraph2 = patch(_requestConfigGraph2 ?? {});
}

let _requestConfigSuggest: Partial<AxiosRequestConfig> | undefined;
export function getSuggestRequestConfig() {
  return _requestConfigSuggest;
}
export function setSuggestRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSuggest = value;
}
export function patchSuggestRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSuggest = patch(_requestConfigSuggest ?? {});
}

let _requestConfigCertificates: Partial<AxiosRequestConfig> | undefined;
export function getCertificatesRequestConfig() {
  return _requestConfigCertificates;
}
export function setCertificatesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCertificates = value;
}
export function patchCertificatesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCertificates = patch(_requestConfigCertificates ?? {});
}

let _requestConfigEmail: Partial<AxiosRequestConfig> | undefined;
export function getEmailRequestConfig() {
  return _requestConfigEmail;
}
export function setEmailRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigEmail = value;
}
export function patchEmailRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigEmail = patch(_requestConfigEmail ?? {});
}

let _requestConfigPassword: Partial<AxiosRequestConfig> | undefined;
export function getPasswordRequestConfig() {
  return _requestConfigPassword;
}
export function setPasswordRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPassword = value;
}
export function patchPasswordRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPassword = patch(_requestConfigPassword ?? {});
}

let _requestConfigFilesGET: Partial<AxiosRequestConfig> | undefined;
export function getFilesGETRequestConfig() {
  return _requestConfigFilesGET;
}
export function setFilesGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigFilesGET = value;
}
export function patchFilesGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigFilesGET = patch(_requestConfigFilesGET ?? {});
}

let _requestConfigFilesPUT: Partial<AxiosRequestConfig> | undefined;
export function getFilesPUTRequestConfig() {
  return _requestConfigFilesPUT;
}
export function setFilesPUTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigFilesPUT = value;
}
export function patchFilesPUTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigFilesPUT = patch(_requestConfigFilesPUT ?? {});
}

let _requestConfigStream: Partial<AxiosRequestConfig> | undefined;
export function getStreamRequestConfig() {
  return _requestConfigStream;
}
export function setStreamRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigStream = value;
}
export function patchStreamRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigStream = patch(_requestConfigStream ?? {});
}

let _requestConfigDownload3: Partial<AxiosRequestConfig> | undefined;
export function getDownload3RequestConfig() {
  return _requestConfigDownload3;
}
export function setDownload3RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDownload3 = value;
}
export function patchDownload3RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDownload3 = patch(_requestConfigDownload3 ?? {});
}

let _requestConfigDownload4: Partial<AxiosRequestConfig> | undefined;
export function getDownload4RequestConfig() {
  return _requestConfigDownload4;
}
export function setDownload4RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDownload4 = value;
}
export function patchDownload4RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDownload4 = patch(_requestConfigDownload4 ?? {});
}

let _requestConfigForget: Partial<AxiosRequestConfig> | undefined;
export function getForgetRequestConfig() {
  return _requestConfigForget;
}
export function setForgetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigForget = value;
}
export function patchForgetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigForget = patch(_requestConfigForget ?? {});
}

let _requestConfigMeGET: Partial<AxiosRequestConfig> | undefined;
export function getMeGETRequestConfig() {
  return _requestConfigMeGET;
}
export function setMeGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigMeGET = value;
}
export function patchMeGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigMeGET = patch(_requestConfigMeGET ?? {});
}

let _requestConfigMePOST: Partial<AxiosRequestConfig> | undefined;
export function getMePOSTRequestConfig() {
  return _requestConfigMePOST;
}
export function setMePOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigMePOST = value;
}
export function patchMePOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigMePOST = patch(_requestConfigMePOST ?? {});
}

let _requestConfigMeDELETE: Partial<AxiosRequestConfig> | undefined;
export function getMeDELETERequestConfig() {
  return _requestConfigMeDELETE;
}
export function setMeDELETERequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigMeDELETE = value;
}
export function patchMeDELETERequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigMeDELETE = patch(_requestConfigMeDELETE ?? {});
}

let _requestConfigPassword2: Partial<AxiosRequestConfig> | undefined;
export function getPassword2RequestConfig() {
  return _requestConfigPassword2;
}
export function setPassword2RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPassword2 = value;
}
export function patchPassword2RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPassword2 = patch(_requestConfigPassword2 ?? {});
}

let _requestConfigWs: Partial<AxiosRequestConfig> | undefined;
export function getWsRequestConfig() {
  return _requestConfigWs;
}
export function setWsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigWs = value;
}
export function patchWsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigWs = patch(_requestConfigWs ?? {});
}